/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { CodeBlock } from '@neo4j-ndl/react';
import { type Meta, type StoryObj } from '@storybook/react-vite';

import {
  CodeDefault,
  CodeDefaultSrc,
  CodeDisabled,
  CodeDisabledSrc,
  CodeFull,
  CodeFullSrc,
  CodeLanguages,
  CodeLanguagesSrc,
  CodeLineNumbers,
  CodeLineNumbersSrc,
  CodeOverflow,
  CodeOverflowSrc,
  CodeWithActions,
  CodeWithActionsSrc,
  CodeWithHeader,
  CodeWithHeaderSrc,
} from './index';

const componentMeta: Meta<typeof CodeBlock> = {
  component: CodeBlock,
  id: 'components-code-block',
  parameters: {
    controls: { disable: true },
  },
  tags: ['docsPage'],
  title: 'Components/CodeBlock',
};

export default componentMeta;

export const Default: StoryObj<typeof CodeBlock> = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: CodeDefaultSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: CodeDefault,
};

export const WithActions: StoryObj<typeof CodeBlock> = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: CodeWithActionsSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: CodeWithActions,
};

export const WithHeader: StoryObj<typeof CodeBlock> = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: CodeWithHeaderSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: CodeWithHeader,
};

export const Overflow: StoryObj<typeof CodeBlock> = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: CodeOverflowSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: CodeOverflow,
};

export const Disabled: StoryObj<typeof CodeBlock> = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: CodeDisabledSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: CodeDisabled,
};

export const LineNumbers: StoryObj<typeof CodeBlock> = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: CodeLineNumbersSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: CodeLineNumbers,
};

export const Languages: StoryObj<typeof CodeBlock> = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: CodeLanguagesSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: CodeLanguages,
};

export const Full: StoryObj<typeof CodeBlock> = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: CodeFullSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: CodeFull,
};
